import { Component, Input, Output, EventEmitter } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { Observable, Subscription } from 'rxjs';
import { EntityFileModel } from 'src/app/core/models/file/entity-file-model';
import { FileManagementService } from 'src/app/core/services/list-services/file-mangement.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { EntityFileUploadModel } from 'src/app/core/models/file/entity-file-upload-model';
import { GlobalComponent } from 'src/app/global-component';
import { FileUploadModalService } from '../../../core/services/modal-services/file-upload-modal.service';
import { DomSanitizer } from '@angular/platform-browser';
import { OpenModalService } from 'src/app/core/services/modal-services/open-modal.service';
import { PdfViewerModalService } from 'src/app/core/services/modal-services/pdf-viewer-modal.service';
import { FileManagementSortBy } from 'src/app/core/enums/sort-by-options/file-management-sort-enum';
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { TableConfigurationModel } from 'src/app/core/models/table/table-configuration.model';
import { ListLayoutExtendableComponent } from '../list-layout/list-layout-extendable/list-layout-extendable.component';
import { ListFilterModel } from 'src/app/core/models/table/list-filter.model';
import { TableActionsModel } from 'src/app/core/models/table/table-action.model';
import { ServiceData } from 'src/app/core/models/table/service-data.model';
import { SortByTypeEnum } from 'src/app/core/enums/list-layout/sort-type-enum';
import { EmitSortModel } from 'src/app/core/models/table/emit-sort.model';
import { FileManagementListTableConfig } from './configs/table-file-management-list.config';
import { AIChatModalService } from 'src/app/core/services/modal-services/ai-chat-modal.service';
import { ActionIdEnum } from 'src/app/core/enums/list-layout/action-id-enum';
import { ButtonIdEnum } from 'src/app/core/enums/list-layout/button-id-enum';
import { TagControllerModalService } from 'src/app/core/services/modal-services/tag-controller-modal.service';
import { AiApiService } from 'src/app/core/services/ai-api.service';
import Swal from 'sweetalert2';
import { KeywordSearchModalService } from 'src/app/core/services/modal-services/keyword-search-modal.service';
import { FileRequestModel } from 'src/app/core/models/file/file-request-model';
import { SecurityOperations } from 'src/app/core/security/security-operations';
import { Router } from '@angular/router';

@Component({
  selector: 'app-file-management',
  templateUrl: './file-management.component.html',
  styleUrls: ['./file-management.component.scss'],
  providers: [FileManagementService, DecimalPipe]
})

export class FileManagementComponent extends ListLayoutExtendableComponent {

  tableConfig: TableConfigurationModel = new TableConfigurationModel();

  serviceData: ServiceData = new ServiceData();

  protected override searchPlaceHolderText: string = $localize`:@@:Search for files by name`;

  sortBy: FileManagementSortBy = FileManagementSortBy.None;
  enumFileManagementSortBy = FileManagementSortBy;

  override listItemsObservable!: Observable<EntityFileModel[]>;

  viewableExtensions = GlobalComponent.viewableExtensions;

  @Input() public entityId: string | undefined;
  @Input() public entityName?: string;
  @Input() public entityTypeId: number = EntityTypeEnum.User;
  @Input() public entityFiles: any[] | undefined = undefined;
  @Input() public customTable: FileManagementListTableConfig | undefined = undefined;
  @Input() public customTitle: string | undefined = undefined;


  
  @Output() filesIdsToAddChanged = new EventEmitter<any>();

  entityFileUpload: EntityFileUploadModel = new EntityFileUploadModel();

  constructor(
    private router: Router,
    protected tagControllerModalService: TagControllerModalService,
    protected myFileUploadModalService: FileUploadModalService,
    protected fileManagementService: FileManagementService,
    protected keywordSearchModalService: KeywordSearchModalService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected aiChatModalService: AIChatModalService,
    protected aiApiService: AiApiService,
    protected override pdfModalService: PdfViewerModalService,
    protected override authMyFileService: AuthMyfileService,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override openModalService: OpenModalService,
  ) {
    super(myFileApiService, sanitizer, pdfModalService, authMyFileService, toasterNotificationService, openModalService);
  }

  override rowActionSelected(rowAction: TableActionsModel): void {
    switch (rowAction.actionIdSelected) {
      case ActionIdEnum.Download:
        if (rowAction.model && rowAction.model.tags && rowAction.model.tags.includes(GlobalComponent.defaultSystemOcrTag)) {
          if (this.authMyFileService.canAccessOperation(SecurityOperations.ocr.createPdfColorHighlightedSearchTermsFile)) {
            this.download(rowAction.model)
          } else {
            Swal.fire({
              title: $localize`:@@SWAL_OCR_TechPackage: DEFAULT TEXT`,
              html: $localize`:@@SWAL_OCR_TechPackage_OrderNow: DEFAULT TEXT`,
              icon: 'info',
              color: 'var(--vz-body-color)',
              background: 'var(--vz-body-bg)',
              showCancelButton: true,
              confirmButtonColor: 'rgb(3, 142, 220)',
              cancelButtonColor: 'rgb(243, 78, 78)',
              confirmButtonText: $localize`:@@SWAL_Order_On_Marketplace: DEFAULT TEXT`,
              cancelButtonText: $localize`:@@SWAL_Close: DEFAULT TEXT`,
            }).then(result => {
              if (result && result.isConfirmed) {
                this.router.navigate([`/marketplace/marketplace`]);
              }
            })
          }
        } else {
          this.download(rowAction.model)
        }
        break;
      case ActionIdEnum.Delete:
        this.deleteData(rowAction.model.id)
        break;
      case ActionIdEnum.LoadChat:

        if (this.authMyFileService.canAccessOperation(SecurityOperations.ai.aiDocumentInsights)) {
          this.loadAndOpenChat(rowAction.model);
        } else {
          Swal.fire({
            title: $localize`:@@SWAL_AI_DocInsights_TechPackage: D`,
            html: $localize`:@@SWAL_AI_DocInsights_TechPackage_OrderNow:`,
            icon: 'info',
            color: 'var(--vz-body-color)',
            background: 'var(--vz-body-bg)',
            showCancelButton: true,
            confirmButtonColor: 'rgb(3, 142, 220)',
            cancelButtonColor: 'rgb(243, 78, 78)',
             confirmButtonText: $localize`:@@SWAL_Order_On_Marketplace: DEFAULT TEXT`,
              cancelButtonText: $localize`:@@SWAL_Close: DEFAULT TEXT`,
          }).then(result => {
            if (result && result.isConfirmed) {
              this.router.navigate([`/marketplace/marketplace`]);
            }
          })
        }


        break;
      case ActionIdEnum.View:

        if (rowAction.model && rowAction.model.tags && rowAction.model.tags.includes(GlobalComponent.defaultSystemOcrTag)) {
          if (this.authMyFileService.canAccessOperation(SecurityOperations.ocr.createPdfColorHighlightedSearchTermsFile)) {
            this.viewDocument(rowAction.model)
          } else {
            Swal.fire({
               title: $localize`:@@SWAL_OCR_TechPackage:`,
              html: $localize`:@@SWAL_OCR_TechPackage_OrderNow:`,
              icon: 'info',
              color: 'var(--vz-body-color)',
              background: 'var(--vz-body-bg)',
              showCancelButton: true,
              confirmButtonColor: 'rgb(3, 142, 220)',
              cancelButtonColor: 'rgb(243, 78, 78)',
              confirmButtonText: $localize`:@@SWAL_Order_On_Marketplace: DEFAULT TEXT`,
              cancelButtonText: $localize`:@@SWAL_Close: DEFAULT TEXT`,
            }).then(result => {
              if (result && result.isConfirmed) {
                this.router.navigate([`/marketplace/marketplace`]);
              }
            })
          }
        } else {
          this.viewDocument(rowAction.model)
        }


        break;
      case ActionIdEnum.Edit:
        //Edit is here for the ability to view document via name click 

        if (rowAction.model && rowAction.model.tags && rowAction.model.tags.includes(GlobalComponent.defaultSystemOcrTag)) {
          if (this.authMyFileService.canAccessOperation(SecurityOperations.ocr.createPdfColorHighlightedSearchTermsFile)) {
            this.viewDocument(rowAction.model)
          } else {
            Swal.fire({
                title: $localize`:@@SWAL_OCR_TechPackage:`,
              html: $localize`:@@SWAL_OCR_TechPackage_OrderNow:`,
              icon: 'info',
              color: 'var(--vz-body-color)',
              background: 'var(--vz-body-bg)',
              showCancelButton: true,
              confirmButtonColor: 'rgb(3, 142, 220)',
              cancelButtonColor: 'rgb(243, 78, 78)',
               confirmButtonText: $localize`:@@SWAL_Order_On_Marketplace: DEFAULT TEXT`,
              cancelButtonText: $localize`:@@SWAL_Close: DEFAULT TEXT`,
            }).then(result => {
              if (result && result.isConfirmed) {
                this.router.navigate([`/marketplace/marketplace`]);
              }
            })
          }
        } else {
          this.viewDocument(rowAction.model)
        }

        break;

      case ActionIdEnum.OCR:
        if (this.authMyFileService.canAccessOperation(SecurityOperations.ocr.processOCR)) {
          Swal.fire({
            title: $localize`:@@SWAL_OCR_Convert:`,          
            html: $localize`:@@SWAL_OCR_Convert_Text:`,
            color: 'var(--vz-body-color)',
            background: 'var(--vz-body-bg)',
            showCancelButton: true,
            confirmButtonColor: 'rgb(3, 142, 220)',
            cancelButtonColor: 'rgb(243, 78, 78)',
            confirmButtonText: $localize`:@@SWAL_Create_OCR_PDF:Create OCR PDF`,
            cancelButtonText: $localize`:@@SWAL_Cancel:Cancel`,
          }).then(result => {
            if (result && result.isConfirmed) {
              var fileRequest = new FileRequestModel;
              fileRequest.getFileList.entityId = this.entityId;
              fileRequest.getFileList.entityTypeId = this.entityTypeId;
              fileRequest.fileId = rowAction.model.id;
              var sub = this.aiApiService.processOcr(fileRequest).subscribe((result: any) => {
                sub.unsubscribe();
              });
            }
          });
        } else {
          Swal.fire({
             title: $localize`:@@SWAL_OCR_TechPackage:`,
              html: $localize`:@@SWAL_OCR_TechPackage_OrderNow:`,
            icon: 'info',
            color: 'var(--vz-body-color)',
            background: 'var(--vz-body-bg)',
            showCancelButton: true,
            confirmButtonColor: 'rgb(3, 142, 220)',
            cancelButtonColor: 'rgb(243, 78, 78)',
             confirmButtonText: $localize`:@@SWAL_Order_On_Marketplace: DEFAULT TEXT`,
              cancelButtonText: $localize`:@@SWAL_Close: DEFAULT TEXT`,
          }).then(result => {
            if (result && result.isConfirmed) {
              this.router.navigate([`/marketplace/marketplace`]);
            }
          })
        }
        break;
      case ActionIdEnum.Highlight:

        if (this.authMyFileService.canAccessOperation(SecurityOperations.ocr.createPdfColorHighlightedSearchTermsFile)) {

          var sourceOCREntityFileRequest: FileRequestModel = new FileRequestModel;

          sourceOCREntityFileRequest.fileId = rowAction.model.id;
          sourceOCREntityFileRequest.getFileList = new EntityFileModel;
          sourceOCREntityFileRequest.getFileList.entityId = this.entityId;
          sourceOCREntityFileRequest.getFileList.entityTypeId = this.entityTypeId;

          this.keywordSearchModalService.openModal(rowAction.model.fileName, sourceOCREntityFileRequest);

        } else {
          Swal.fire({
            title: $localize`:@@SWAL_OCR_ColorKeywords_TechPackage:`,
            html: $localize`:@@SWAL_OCR_ColorKeywords_TechPackage_OrderNow:`,
            icon: 'info',
            color: 'var(--vz-body-color)',
            background: 'var(--vz-body-bg)',
            showCancelButton: true,
            confirmButtonColor: 'rgb(3, 142, 220)',
            cancelButtonColor: 'rgb(243, 78, 78)',
            confirmButtonText: $localize`:@@SWAL_Order_On_Marketplace: DEFAULT TEXT`,
              cancelButtonText: $localize`:@@SWAL_Close: DEFAULT TEXT`,
          }).then(result => {
            if (result && result.isConfirmed) {
              this.router.navigate([`/marketplace/marketplace`]);
            }
          })
        }
        break;
      case ActionIdEnum.LoadKnowledgeBase:
        this.loadToKnowledgeBase(rowAction.model)
        break;
      case ActionIdEnum.UnloadKnowledgeBase:
        this.unloadFromKnowledgeBase(rowAction.model)
        break;
      // case ActionIdEnum.DeleteVectorStore:
      //   Swal.fire({
      //     title: $localize`:@@SWAL_Delete_From_VectorStore:`,
      //     text: $localize`:@@SWAL_Delete_From_VectorStore_Text:`,
      //     icon: 'warning',
      //     color: 'var(--vz-body-color)',
      //     background: 'var(--vz-body-bg)',
      //     showCancelButton: true,
      //     confirmButtonColor: 'rgb(3, 142, 220)',
      //     cancelButtonColor: 'rgb(243, 78, 78)',
      //     confirmButtonText: $localize`:@@SWAL_OK:Ok`,
      //     cancelButtonText: $localize`:@@SWAL_Cancel:Cancel`,
      //   }).then(result => {
      //     if (result && result.isConfirmed) {
      //       var fileRequest = new FileRequestModel;
      //       fileRequest.getFileList.entityId = this.entityId;
      //       fileRequest.getFileList.entityTypeId = this.entityTypeId;
      //       fileRequest.fileId = rowAction.model.id;
      //       this.aiApiService.vectorStorageDelete(fileRequest).subscribe();
      //     }
      //   });
      //   break;
    }
  }

  override buttonActionSelected(buttonAction: any): void {
    switch (buttonAction) {
      case ButtonIdEnum.CreateNew:
        this.addFiles();
        break;

      default:
        if (buttonAction && buttonAction.buttonId) {
          switch (buttonAction.buttonId) {
            case ButtonIdEnum.Download:
              this.batchDownload(buttonAction.checkedValList);
              break;
            case ButtonIdEnum.Delete:
              this.batchDelete(buttonAction.checkedValList);
              break;
          }

        }
        break;
    }
  }

  override filterSelected(filterSelected: ListFilterModel): void {
    /// method is not currently used here as no filters are being sent but is required by the abstract class to exist here in case it used. 
  }


  ngOnInit(): void {
    if (this.entityId != undefined && this.entityId.length > 0) {

      this.entityFileUpload.entityId = this.entityId;
      this.entityFileUpload.entityTypeId = this.entityTypeId;

      this.listItemsObservable = this.fileManagementService.resultItems$;
      this.total = this.fileManagementService.total$;
      this.isLoading = this.fileManagementService.loading$;

      const subscr = this.isLoading.subscribe(result => {
        if (result) {
          this.serviceData.loadingValue = true;
        } else {
          this.serviceData.loadingValue = false;
        }
      });
      this.unsubscribe.push(subscr);

      const subscr2 = this.listItemsObservable.subscribe(result => {
        this.listItems = Object.assign([], result);
      });
      this.unsubscribe.push(subscr2);

      const subscr3 = this.total.subscribe(result => {
        this.serviceData.totalRecords = this.fileManagementService.totalRecords;
        this.serviceData.pageSize = this.fileManagementService.pageSize;
        this.serviceData.pageIndex = this.fileManagementService.pageIndex;
      });
      this.unsubscribe.push(subscr3);

    } else if (this.entityFiles != undefined) {
      this.listItems = this.entityFiles;
      this.fileManagementService.setClientSideOnlyList = true;
    }

    if (this.customTable) {
      this.tableConfig = this.customTable;
    } else {
      this.tableConfig = new FileManagementListTableConfig();
    }

    if(this.customTitle){
      this.tableConfig.listTitle = this.customTitle;
    }

    this.fileManagementService.getFileList = this.entityFileUpload;
  }

  override ngOnDestroy(): void {
    this.clearSearch(this.fileManagementService);
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }

  loadAndOpenChat(rowModel: any) {
    this.aiChatModalService.setOpenModalId(rowModel.entityId, rowModel.id, this.entityTypeId, rowModel.fileName);
    this.aiChatModalService.openModal(false, true, true, rowModel.tags);
  }

  loadToKnowledgeBase(rowModel: any) {
    var ragEntityFileRequestModel = {
      fileName: rowModel.fileName,
      getFileList: {
        entityId: this.entityId,
        entityTypeId: this.entityTypeId
      },
      tags: rowModel.tags,
      fileId: rowModel.id
    }
    this.serviceData.loadingValue = true;
    this.tagControllerModalService.openModal(ragEntityFileRequestModel);
    var modalSubscription = this.tagControllerModalService.modelChanged.subscribe((result: any) => {
      this.fileManagementService.startIndex = this.fileManagementService.startIndex;
      modalSubscription.unsubscribe();
    })

  }

  unloadFromKnowledgeBase(rowModel: any) {
    var ragEntityFileRequestModel: any = {
      fileName: rowModel.fileName,
      getFileList: {
        entityId: this.entityId,
        entityTypeId: this.entityTypeId
      },
      tags: rowModel.tags,
      fileId: rowModel.id
    }
    this.serviceData.loadingValue = true;
    this.aiApiService.chatKnowledgeBaseDelete(ragEntityFileRequestModel).subscribe((result) => {
      this.fileManagementService.startIndex = this.fileManagementService.startIndex;
    })


  }

  download(data: EntityFileModel) {
    if (data && data.entityId && data.id) {
      this.serviceData.loadingValue = true;
      this.myFileApiService.downloadEntityFile(this.entityTypeId, data.entityId, data.id).subscribe((result: any) => {
        if (result) {
          this.toasterNotificationService.showSuccess($localize`:@@: File Successfully Downloaded ` + data.fileName, $localize`:@@Toast_Success_GeneralTitle:Success`);
        }
        this.serviceData.loadingValue = false;
      });
    }
  }

  viewDocument(data: EntityFileModel) {
    if (data && data.entityId && data.id) {
      this.serviceData.loadingValue = true;
      this.myFileApiService.viewEntityFile(this.entityTypeId, data.entityId, data.id).subscribe((result: any) => {
        if (result) {
          this.pdfModalService.openModal(result, this.entityName);
        }
        this.serviceData.loadingValue = false;
      });
    }
  }

  // Delete Data
  deleteData(entityFileId: string) {
    this.serviceData.loadingValue = true;
    Swal.fire({
      title: $localize`:@@:Delete File`,
      text: $localize`:@@:Are you sure you want to delete this file?`,
      icon: 'warning',
      color: 'var(--vz-body-color)',
      background: 'var(--vz-body-bg)',
      showCancelButton: true,
      confirmButtonColor: 'rgb(3, 142, 220)',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: $localize`:@@SWAL_OK:Ok`,
          cancelButtonText: $localize`:@@SWAL_Cancel:Cancel`,
    }).then(result => {
      if (result && result.isConfirmed) {
        this.entityFileUpload.fileIdsToDelete.push(entityFileId);

        this.myFileApiService.processEntityFiles(this.entityFileUpload).subscribe((result: any) => {
          if (result) {
            this.sortBy = this.sortBy
            this.toasterNotificationService.showSuccess($localize`:@@: File successfully deleted`, $localize`:@@Toast_Success_GeneralTitle:Success`);
          }
          this.entityFileUpload.fileIdsToDelete = [];
          this.fileManagementService.pageSize = this.fileManagementService.pageSize;
          this.serviceData.loadingValue = false;
        });
      } else {
        this.serviceData.loadingValue = false;
      }
    });
  }

  batchDelete(selectedEntityFiles: EntityFileModel[]) {
    this.serviceData.loadingValue = true;
    Swal.fire({
      title: $localize`:@@:Delete Multiple Files`,
      text: $localize`:@@:Are you sure you want to delete these files?`,
      icon: 'warning',
      color: 'var(--vz-body-color)',
      background: 'var(--vz-body-bg)',
      showCancelButton: true,
      confirmButtonColor: 'rgb(3, 142, 220)',
      cancelButtonColor: 'rgb(243, 78, 78)',
       confirmButtonText: $localize`:@@SWAL_OK:Ok`,
          cancelButtonText: $localize`:@@SWAL_Cancel:Cancel`,
    }).then(result => {
      if (result && result.isConfirmed) {
        selectedEntityFiles.forEach(file => {
          if (file.id) {
            this.entityFileUpload.fileIdsToDelete.push(file.id);
          }
        });

        this.myFileApiService.processEntityFiles(this.entityFileUpload).subscribe((result: any) => {
          if (result) {
            this.toasterNotificationService.showSuccess($localize`:@@: File(s) successfully deleted`, $localize`:@@Toast_Success_GeneralTitle:Success`);
          }
          this.entityFileUpload.fileIdsToDelete = [];
          this.serviceData.loadingValue = false;
          this.fileManagementService.pageSize = this.fileManagementService.pageSize;
        });
      } else {
        this.serviceData.loadingValue = false;
      }
    });

  }

  batchDownload(selectedEntityFiles: EntityFileModel[]) {
    this.serviceData.loadingValue = true;
    this.entityFileUpload.fileIds = [];
    selectedEntityFiles.forEach(file => {
      if (file.id) {
        this.entityFileUpload.fileIds?.push(file.id);
      }
    });

    return this.myFileApiService.batchDownloadEntityFiles(this.entityFileUpload).subscribe((result: any) => {
      if (result) {
        this.toasterNotificationService.showSuccess($localize`:@@: File(s) Successfully Downloaded`, $localize`:@@Toast_Success_GeneralTitle:Success`);
      }
      this.serviceData.loadingValue = false;
    });
  }

  addFiles() {
    this.myFileUploadModalService.openModal(this.fileManagementService, this.entityFileUpload, this.entityName);

    /** 
     * This if statement adds the subscription that emits the resulting IDs back to the parent component so that they can be add to that parent components model's zzz.fileUpload.FileIdsToAdd array. Make sure that component injection in the HTML of the parent has (filesIdsToAddChanged) so it can trigger a function to add the array list to the parents model. 
     */
    if (this.entityFileUpload.entityId === undefined) {
      var sub: Subscription = this.myFileUploadModalService.modelChanged.subscribe((result: any) => {
        var today: Date = new Date();
        result.files.forEach((file: File) => {
          var entity: EntityFileModel = new EntityFileModel;
          entity.fileName = file.name;
          entity.fileSize = file.size;
          entity.fileType = file.type;
          entity.modifiedDate = today;
          entity.createdDate = today;
          this.listItems.push(entity);
        })
        this.filesIdsToAddChanged.emit(result.filesToAdd);
        sub.unsubscribe();
      });
    }
  }

  sortByPassedSort(passedSortModel: EmitSortModel) {
    if (passedSortModel.sortSelected == SortByTypeEnum.None) {
      this.serviceSort(this.fileManagementService, '', '');
    } else {
      this.serviceSort(this.fileManagementService, passedSortModel.fieldName, passedSortModel.sortSelected);
    }
  }

}
